import type { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environment/environment';

// Import a custom translation service to get the user's current language
import { TranslationService } from '../common/service/translate.service';

/**
 * Http interceptor that adds the user's current language as a custom header (`lang`)
 * to outgoing HTTP requests targeting the configured API base URL.
 *
 * This allows the backend to serve localized content based on the language preference.
 */
export const userLanguageInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {

  // Check if the request URL is directed to the backend API
  if (req.url.includes(environment.APIBase)) {

    // Inject the translation service to access the current language
    const translationService = inject(TranslationService);

    // Clone the request and add the 'lang' header with the current language or fallback to 'en-US'
    const newReq = req.clone({
      setHeaders: {
        lang: translationService?.getCurrentLanguage() ?? 'de-DE',
      },
    });

    // Forward the modified request to the next handler
    return next(newReq);
  }

  // If the request is not directed to the API, forward it without modification
  return next(req);
};
